'use strict';

/* global $ */

let settings = {
    mapSelector: '.js-contacts__map',
    map: {
        zoom: 16,
        controls: ['default']
    },
    ymapsScriptSrc: 'https://api-maps.yandex.ru/2.1/?lang=ru_RU'
};

class ContactsMap {
    constructor(options) {
        this.opt = $.extend({}, settings, options);
        this.init();
    }
    init() {
        console.log('[ ContactsMap/init ]');

        this.$maps = $(this.opt.mapSelector);

        if (this.$maps.length) {
            $.getScript(this.opt.ymapsScriptSrc).done(() => {
                ymaps.ready(() => {
                    this.initMaps();
                });
            }).fail(() => {
                throw new Error(`Can't load script ${ this.opt.ymapsScriptSrc }`);
            });
        }
    }
    initMaps() {
        for (let i = 0; i < this.$maps.length; i ++) {
            this.$map = this.$maps.eq(i);

            let coords = this.$map.data('coords').split(',');
            let opts = $.extend({}, this.opt.map, {
                center: coords
            });

            let map = new ymaps.Map(this.$map.get(0), opts);

            let placemark = new ymaps.Placemark(coords, {
                iconCaption: 'Авиценна'
            }, {
                preset: 'islands#blueCircleDotIconWithCaption'
            });
            map.geoObjects.add(placemark);
            map.behaviors.disable('scrollZoom');
        }
    }
}


export {
    ContactsMap
};
